export enum DATA_QA {
  ROOT = 'phone-change-log',
}
